module.exports = __webpack_public_path__ + "static/media/YM51_1.0a9c900b.jpg";